const reviewDistributions = [
	{
		path: '/community/contents/reviews/distribution',
		name: 'community-contents-review-distributions-list',
		component: () => import('@/views/community/review-distributions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
]

export default reviewDistributions
